// extracted by mini-css-extract-plugin
module.exports = {"lds-ellipsis":"style_lds-ellipsis__1j9-5","lds-ellipsis1":"style_lds-ellipsis1__16qCJ","lds-ellipsis2":"style_lds-ellipsis2__3JWKc","lds-ellipsis3":"style_lds-ellipsis3__3uvx4"};